<template>
  <div>
    <div class="search flex">
      <span class="tit">系统文章管理</span>
      <div class="flex">
        <el-button @click="toAdd()" size="mini" class="addBtn">添加系统文章</el-button>
        <el-input class="addART"
                  placeholder="关键字" clearable
                  v-model="condition.title"
                  @change="skipPage(1)"
                  suffix-icon="el-icon-search">
        </el-input>
      </div>
    </div>

    <div class="typeHead">
      <div class="medicineType flex">
        <span class="typeTit">类型：</span>
        <div class="medicineTypeL">
          <span v-for="item in itemList"
                :key="item.id">
            <label :class="active.itemId===item.id?'activeClass':''"
                   @click="changeItem(item)">
              {{item.itemName}}
            </label>
          </span>
        </div>
      </div>
      <div class="medicineType flex">
        <span class="typeTit">文章类型：</span>
        <div class="medicineTypeL">
          <span v-for="subitem in subitemList"
                :key="subitem.id">
            <label :class="active.subitemId===subitem.id?'activeClass':''"
                   @click="changeSubitem(subitem)">
              {{subitem.subName}}
            </label>
          </span>
        </div>
      </div>
    </div>
    <div class="instrument mt-5">
      <el-table :data="page.rows"
                class="record-table"
                :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
                height="calc(100vh - 400px)"
                max-height="calc(100vh - 400px)">
        <el-table-column label="标题" prop="title" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="简述" prop="summary" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="状态" prop="status" align="center" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.articleStatus===0" class="yellow common" @click="changeStatus(scope.row, 1)">
              禁用
            </span>
            <span v-else-if="scope.row.articleStatus===1" class="green common" @click="changeStatus(scope.row, 0)">
              启用
            </span>
            <span v-else class="pink common" @click="changeStatus(scope.row, 1)">-</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" prop="updateDate" align="center">
          <template slot-scope="scope">
            {{ handleDate(scope.row.updateDate) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button class="btn" type="text" size="small" @click="toEdit(scope.row)">编辑</el-button>
            <el-popconfirm
                confirm-button-text='好的'
                cancel-button-text='不用了'
                icon="el-icon-info"
                icon-color="red"
                @confirm="del(scope.row.id)"
                title="确定删除吗？">
              <el-button slot="reference" class="btn" type="text" size="small">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>

      </el-table>
      <el-pagination
          class="pagination"
          background
          prev-text="Prev"
          next-text="Next"
          @current-change="skipPage"
          :current-page="page.current"
          :page-size="page.size"
          layout="prev, pager, next"
          :total="page.total">
      </el-pagination>
    </div>


  </div>
</template>

<script>
import base from '@/api/common';

export default {
  name: "articleSystemList",
  data() {
    return {
      page: {
        current: 1,
        size: 9,
        total: 110,
        rows: [],
        name: ''
      },

      itemList: [],
      active: {
        itemId: null,
        subitemId: null
      },
      subitemList: [],
      condition: {
        dictCatalogSubitemId: null,
        title: '',
      },
      systemArticleList: [],
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    //获得数据
    getData() {
      let that = this;
      this.$ajax.get(base.api.dict.edit.item.listByCode.replace("{code}", "article_system")).then((res) => {
        if (res.data.status === 'success') {
          that.itemList = res.data.list;
          this.changeItem(that.itemList[0]);
        } else {
          that.$message.error(res.data.message);
        }
      }).catch((err) => {
        console.error(err)
        that.$message.error("获取字典失败");
      })
    },
    //跳页
    skipPage(cur) {
      this.page.current = cur;
      this.getSystemArticle();
    },
    //改变item
    changeItem(item) {
      this.active.itemId = item.id;
      this.subitemList = item.subitemList;
      this.changeSubitem(item.subitemList[0])
    },
    //改变subitem
    changeSubitem(subItem) {
      this.active.subitemId = subItem.id;
      this.skipPage(1);
    },
    //获得系统文章
    getSystemArticle() {
      let that = this;
      this.condition.dictCatalogSubitemId = this.active.subitemId;
      this.$ajax.post(base.manager_api.article.system.page.replace("{currentPage}", this.page.current).replace("{size}", this.page.size), this.condition).then((res) => {
        if (res.data.status === 'success') {
          that.page.current = res.data.current;
          that.page.size = res.data.size;
          that.page.total = res.data.total;
          that.page.rows = res.data.rows;
        } else {
          that.$message.error(res.data.message);
        }
      }).catch((err) => {
        console.error(err)
        that.$message.error("获取系统文章失败");
      })
    },
    //跳转到添加界面
    toAdd() {
      this.$router.push({path: 'edit', query: {status: '0'}})
    },
    toEdit(obj) {
      this.$router.push({path: 'edit', query: {status: '1', id: obj.id}})
    },
    //删除
    del(id) {
      let that = this;
      this.$ajax.get(base.manager_api.article.system.delete.replace("{id}", id)).then((res) => {
        if (res.data.status === 'success') {
          that.$message.success("操作成功");
          that.getSystemArticle();
        } else {
          that.$message.error(res.data.message);
        }
      }).catch((err) => {
        console.error(err)
        that.$message.error("操作失败")
      })
    },
    changeStatus(obj, status) {
      let that = this;
      this.$ajax.get(base.manager_api.article.system.updateStatus.replace("{id}", obj.id).replace("{status}", status)).then((res) => {
        if (res.data.status === 'success') {
          that.$message.success("操作成功");
          obj.articleStatus = status;
        } else {
          that.$message.error(res.data.message);
        }
      }).catch((err) => {
        console.error(err)
        that.$message.error("操作失败");
      })
    },
    handleDate(date) {
      return date.replace("T", " ");
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/admin.scss';

</style>